import { aCurrentUser, mockUserProfileOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUserProfileOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          currentUser: aCurrentUser(),
          version: 'local',
        },
      });
    }
  ),
];
